import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://90046c0532e197f1d2a9bbdb69c2c30c@o1191715.ingest.us.sentry.io/4506858123952128",
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/astro/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  // Define how likely traces are sampled. Adjust this value in production,
  // or use tracesSampler for greater control.
  tracesSampleRate: 0.01,
  // Enable logs to be sent to Sentry
  enableLogs: true,
});
